<template>
  <main class="px-8 mx-auto my-0 max-w-screen-2xl md:px-24 lg:px-32 xl:px-48">
    <slot />
  </main>
</template>
